import { Injectable, EventEmitter } from '@angular/core';
import * as SwWebUploader from 'webuploader';
import { SwHttpClientService } from '../sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwJwtService } from '../sw-jwt.service';
import { SystemIdService } from './system-id.service';
import { SwMassageBoxService } from '../sw-massage-box.service';
import { Subject, Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SwUploadService {

  /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl:string = environment.fileWebAPI

  /**
   * @ignore
   * 上传路径
   */
  uploadPath:string 

  /**
   * @ignore
   * webUploader 文件上传初始化的 uploader
   */
  uploader: any

  infoEmit = new EventEmitter();

  constructor(
    private http:SwHttpClientService,
    private Jwt:SwJwtService,
    private systemId: SystemIdService,
    private box:SwMassageBoxService,
  ) { }
   /**
   * @ignore
   * 创建上传对象需要的参数
   */
  option = {
    server:this.fileUrl + "file/fileUpload", //文件接收服务器
    auto: true,   //自动上传
    resize: false,  //
    dnd: '#uploader',   //指定 Drag And Drop 拖拽的容器,如果不知道,则不启动
    // paste: '#uploader',  //指定监听paste事件的容器,如果不指定则不起都过此功能.此功能为通过粘贴来添加截屏的图片,建议设置为document.body
    pick: {
      id: '#filePicker',
      label: '选择文件',
      multiple: false,   //只能单张上传
    },
    accept: {   //只允许上传图片文件
      title: '',
      extensions: 'gif,jpg,jpeg,bmp,png',
      // mimeTypes: 'image/*',
      //点击选择文件之后会有延迟,解决方法:
      mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png,image/bmp'
    },
    fileNumLimit:100 , 
    compress:false,
    chunked:true,     //分片上传大文件
    chunkSize:1024*1024*1,
    chunkRetry:5,     // 如果某个分片由于网络出现问题错误,允许自动上传多少次
    threads:3,        //最大上传并发数
    method:'Post',
    fileSizeLimit:undefined,  //验证文件总大小是否超出限制,超出则不允许加入队列
    fileSingleSizeLimit:undefined,  //验证单个文件大小是否超出限制,超出则不允许加入队列
    duplicate:true,   //允许重复上传文件
  
  }

  uploadedFileUuids:any[] = []
  valueUpdated: Subject<any> = new Subject<any>();
  /**
   * 预览文件
   * @param file  文件对象
   * @param fileCode  文件上传策略
   */
  uploadFile(files:any[],fileCode:string){
    let myDivBox = document.createElement('div')
    let myDiv = document.createElement('div')
    myDivBox.id = "uploader"
    myDiv.id = "uploader" + new Date().getTime()
    myDiv.innerHTML = "选择文件"
    myDivBox.style.display = "none"
    document.body.appendChild(myDivBox) 
    myDivBox.appendChild(myDiv)

    this.option.pick.id = '#'+ myDiv.id
    this.http.Get(this.fileUrl +'fileConfig/queryFileConfigOfUploadBeforeByCode?code='+fileCode)
    .subscribe(ret=>{
      if(ret && ret.code == 200){
        let uploadObj = ret.data;
        this.option.fileSingleSizeLimit = uploadObj.config.allowSize? uploadObj.config.allowSize *1024 *1024 : undefined;
        this.option.accept.extensions = uploadObj.suffix
        let arr = uploadObj.suffix.split(',')  
        arr = arr.map(item=>'.'+item)
        this.option.accept.mimeTypes = arr.join(',')
        this.uploader = SwWebUploader.create(this.option)
        this.clickToSelect(files,fileCode,myDivBox,myDiv)
        setTimeout(() => {
          this.uploader.refresh()
          this.uploader.addFiles(files)
        }, 10);
        
        
      }

    }) 
    this.valueUpdated.subscribe(x=>{
      return x
    })
  }

  clickToSelect(files,fileCode,myDivBox,myDiv){
    //将上次的已将上传的文件信息清空
    //当文件加到队列之前
    this.uploader.on('beforeFileQueued',(file)=>{
      
      if(this.option.accept.extensions && this.option.accept.extensions.indexOf(file.ext.toLocaleLowerCase()) == -1){
        
        //没有这个后缀
        this.box.danger('文件格式不正确')
        return
      }
      if(file.size > this.option.fileSingleSizeLimit){
          this.box.danger(file.name+'大小超过限制')
          return
      }
    })

    //文件上传之前触发,设置参数
    this.uploader.on('uploadBeforeSend',(obj, data, headers)=>{
      //增加请求头
      headers['AuthorizationU'] = this.Jwt.getToken('token'),
      data.id = obj.file.id ,              //wu_id,webUpload组件自己排的ID，通过此参数获取相应MD5值
      data.size = obj.file.size ,          //文件总文件字节大小
      data.byteNow = obj.blob.size ,       //定义的每个分片的字节大小
      data.chunks = obj.chunks ,           //总分片数
      data.chunk = obj.chunk ,             //当前分片数，当前是第几分片
      data.name = obj.file.name ,          //文件名
      data.file = JSON.stringify(obj.blob),  //分片对象
      // data.md5 = Md5.hashStr(obj.file.id + ':'+obj.file.name + obj.file.lastModifiedDate+'#'),        //将md5值进行Md5加密 , 文件的MD5值String , 后台根据这个md5值进行分片的合并,所以,每一个文件的所有分片的md5要一致
      data.sysId = this.systemId.getSystemId(),                   //系统编号 随便写
      // data.functionId = this.fileFunctionId ? this.fileFunctionId : '1',                //策略id
      data.code = fileCode ? fileCode : 'aa',                //策略id
      data.uploadPath = this.uploadPath ?  this.uploadPath : 'aaa/',             //上传路径 随便写的字符串
      data.uploadDirectory = environment.uploadDirectory           //项目路径
    })

    //上传成功触发
    this.uploader.on('uploadSuccess',(file,response)=>{
      if(response.code == 200){
        this.uploadedFileUuids.push(response.data.uuid)
        if(files.length == this.uploadedFileUuids.length){
          //如果没有在上传中状态的文件,说明全部上传完毕,获取所有上传完文件信息
          //上传完成后重新获取所有已经上传的所有的文件信息,将数组更新,重新渲染页面
          this.emit(this.uploadedFileUuids)
          // this.getShowList2(this.uploadedFileUuids)
          this.uploadedFileUuids = []    // 每次重新选择文件上传的时候都将 uuid数组重置为空
        }
      } else {
        //相当于上传失败
        this.box.danger(response.msg)
      }
      myDivBox.removeChild(myDiv)
      document.body.removeChild(myDivBox)
    })

    //上传失败触发
    this.uploader.on('uploadError',(file,reason)=>{
      this.box.danger("上传失败")
      myDivBox.removeChild(myDiv)
      document.body.removeChild(myDivBox)
    })
    
    //解决第一次选择文件没有上传,重新选择文件出现队列错误的问题
    this.uploader.reset()
  }

    /**
    * 根据文件信息的fileIndoId进行回显(从文件系统中查),文件的sort默认都0,且不能修改,业务只有排序是修改的附件表中的文件属性
    * @ignore
    * @param ids
    */
  getShowList2(ids){
    let datas = {
      ids:ids
    }
    this.http.Post(this.fileUrl + "fileInfo/queryByIdList" , datas).subscribe(res=>{
      if(res && res.code == 200){
        let resArr = res.data.filter(item=> !item.isDeleted)  //过滤掉伪删除的文件
        this.valueUpdated.next(resArr)
      } else{
        this.box.danger("网络错误,无法获取列表")
      }
    })
  }
  
  public emit(emitData){
    return this.infoEmit.emit(emitData);
  }

  public getEventObservable():Observable<any>{
    return this.infoEmit.pipe(share());
  }

}
